import toast from 'react-hot-toast'

import { downloadCSV } from '@fv/client-core'

export const NO_EXPORT_ATTR = 'data-no-export'

export function composePath(
  report: string,
  params: { [key: string]: string | undefined },
  reportType: 'fv' | 'engine' = 'fv',
) {
  const query = new URLSearchParams()
  const root = reportType === 'fv' ? 'reports' : 'engine-reports'

  Object.keys(params).forEach(k => {
    const value = params[k]
    if (value) query.set(k, value)
  })

  return `/${root}/${report}?${query.toString()}`
}

// https://www.geeksforgeeks.org/how-to-export-html-table-to-csv-using-javascript
export function downloadReport(reportName: string): void {
  const csvData = []
  const rows = document.getElementsByTagName('tr')

  if (!rows?.length) {
    toast.error('No data available.')
    return
  }

  for (let i = 0; i < rows.length; i++) {
    const columns = rows[i].querySelectorAll('td,th')
    const csvRow = []

    for (let j = 0; j < columns.length; j++) {
      const clone = columns[j].cloneNode(true) as HTMLElement
      clone.querySelectorAll(`[${NO_EXPORT_ATTR}]`)?.forEach(n => n.remove())

      csvRow.push(
        clone.getAttribute('data-export-value') || (clone.textContent ?? ''),
      )
    }

    csvData.push(csvRow.map(r => `"${r?.replace(/"/g, '""') ?? ''}"`).join(','))
  }

  downloadCSV(csvData, reportName)
  toast.success('Report downloaded successfully.')
}
